import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles((theme) => ({
  text: {
    marginTop: "20px",
  },
  modal: {
    maxWidth: "760px",
  },
}));

export default styles;
